/* freeze deck so prev and next become temporary noops */

function freeze(options) {
    let frozen = false;

    return deck => {

        deck.freeze = () => {
            frozen = true;
            deck.fire('freeze');
        }

        deck.unfreeze = () => {
            frozen = false;
            deck.fire('unfreeze');
        }

        deck.frozen = () => frozen;

        deck.on('next', e => !frozen);
        deck.on('prev', e => !frozen);
    }
}

export default freeze;